export default __webpack_public_path__ + "4cd0d7ae5e3042f3651aad2a46b48a97.png";